import { Clickable, Col, Icon, Row, Text } from 'components';
import { theme } from 'lib';
import { ValueInput } from 'screens/Admin/components';

const emptyStock = { description: '', qty: '', priceInUSD: '' };

const Stock = ({ stock, setStock, price, error }) => {
  function addStock() {
    setStock([...stock, emptyStock]);
  }

  function removeStock(idx) {
    setStock(stock.filter((x, i) => idx !== i));
  }

  function handleChange(idx, field, value) {
    if (field === 'qty') {
      value = value.replace(',', '');

      if (isNaN(Number(value))) return;
    }

    setStock(
      stock.map((x, i) => {
        if (i !== idx) return x;

        return {
          ...x,
          [field]: value
        };
      })
    );
  }

  return (
    <Col noFlex>
      <Text marg="24px 16px 5px" b2 med>
        Stock
      </Text>

      <Row noFlex>
        <Text wid="15px" marg="0 12px 0 0" c1 med>
          #
        </Text>

        <Text wid="160px" marg="0 24px 0 0" c1 med>
          Description
        </Text>

        <Text wid="80px" marg="0 24px 0 0" c1 med>
          In stock
        </Text>

        {/*
          <Text marg='0 24px 0 0' c1 med>
            Individual price
          </Text>
        */}
      </Row>

      <Col noFlex>
        {stock.map((x, i) => (
          <Row centerAll key={i} noFlex marg="0 0 12px">
            <Text marg="0 12px 0 0" wid="15px">
              {i}
            </Text>

            <ValueInput
              marg="0 24px 0 0"
              wid="150px"
              placeholder='eg. "M" for clothing'
              value={stock[i]['description']}
              onChange={({ target }) => handleChange(i, 'description', target?.value || '')}
            />

            <ValueInput
              currency
              marg="0 24px 0 0"
              wid="70px"
              value={stock[i]['qty']}
              placeholder="eg. 100"
              onChange={({ target }) => handleChange(i, 'qty', target?.value || '')}
            />

            {/*
              <ValueInput
                currency
                wid='70px'
                placeholder={`$${price}`}
                currency
                prefix='$'
                value={stock[i]['priceInUSD']}
                onChange={({ target }) => handleChange(i, 'priceInUSD', target?.value || '')}
              />
            */}

            {stock.length > 1 && (
              <Clickable marg="0 0 0 0" onClick={() => removeStock(i)}>
                <Icon type="delete" />
              </Clickable>
            )}
          </Row>
        ))}
      </Col>

      <Clickable onClick={addStock}>
        <Row center>
          <Icon type="add" dimensions={12} marg="0 6px 0 0" />

          <Text b2 med>
            Add item
          </Text>
        </Row>
      </Clickable>

      {error && (
        <Row start>
          <Text c1 bold marg="4px 0 0 16px" col={theme.SECONDARY}>
            {error}
          </Text>
        </Row>
      )}
    </Col>
  );
};

export default Stock;
